import { render, staticRenderFns } from "./CertificateContent5.vue?vue&type=template&id=146623f6&scoped=true&"
import script from "./CertificateContent5.vue?vue&type=script&lang=js&"
export * from "./CertificateContent5.vue?vue&type=script&lang=js&"
import style0 from "./CertificateContent5.vue?vue&type=style&index=0&id=146623f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146623f6",
  null
  
)

export default component.exports